import { Info } from "lucide-react";
import type { Question } from "../types";
import { Markdown } from "@/lib/markdown";

export function InfoBlock({ question }: { question: Question }) {
  return (
    <div data-question-id={question.id} className="flex gap-3 py-4">
      <Info aria-hidden="true" className="mt-1 h-5 w-5 shrink-0 text-accent" />
      <div className="flex flex-col gap-1">
        <h3 className="text-lg">{question.title}</h3>
        <Markdown source={question.body} className="text-fg" />
      </div>
    </div>
  );
}
